import * as React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { ROUTES } from 'Constants';

/**
 * Permanent client-side redirects from the two legacy staff user pages to the merged
 * /users/:id/:tab? page. Kept indefinitely — staff bookmarks and emailed links
 * (e.g. the user-type-requested email's Customer Account Url) still use the old paths.
 */

/** /search-results/:id showed the user's activity tables, bookings first — preserve that intent. */
export function LegacySearchResultsRedirect() {
	const { id } = useParams<{ id: string }>();
	const { search } = useLocation();
	return <Navigate to={`${ROUTES.USER_DETAIL.url(id!, 'bookings')}${search}`} replace />;
}

/**
 * /staff-account-details/:id/:tab? used the same tab names as the new page, except a few old
 * links pointed at a "details" tab that never existed (the old page fell back to account).
 * The query string carries across — some entry points pass ?search= for the target tab.
 */
export function LegacyStaffAccountDetailsRedirect() {
	const { id, tab } = useParams<{ id: string; tab: string }>();
	const { search } = useLocation();
	const mappedTab = !tab || tab === 'details' ? 'account' : tab;
	return <Navigate to={`${ROUTES.USER_DETAIL.url(id!, mappedTab)}${search}`} replace />;
}
